import TypeToReducer from 'type-to-reducer';
import set from 'lodash/set';
import { PENDING, FULFILLED, REJECTED } from 'redux-promise-middleware';
import {
  RESET_SUBACCOUNT_FORM,
  GET_SUBACCOUNT_BY_ID,
  GET_SUBACCOUNT_FORM_CONFIG,
  MODIFY_EDITING_SUBACCOUNT,
  MODIFY_CUSTOM_FIELD_EDITING_SUBACCOUNT, //Groups
  ADD_CUSTOM_FIELD_EDITING_SUBACCOUNT,
  REMOVE_CUSTOM_FIELD_EDITING_SUBACCOUNT,
} from 'subaccounts/constants';

export const initialState = {
  isFetchingConfig: false,
  isFetching: false,
  isSaving: false,
  editing: { customFields: [] },
};

export const resetForm = (state) => ({ ...initialState });

export const getByIdPending = (state) => ({ ...state, isFetching: true });

export const getByIdRejected = (state) => ({ ...state, isFetching: false });

export const getByIdFulfilled = (state, { payload }) => ({
  ...state,
  isFetching: false,
  editing: { ...payload.account },
});

export const getConfigPending = (state) => ({ ...state, isFetchingConfig: true });
export const getConfigRejected = (state) => ({ ...state, isFetchingConfig: false });
export const getConfigFulfilled = (state) => ({ ...state, isFetchingConfig: false });

export const modifySubaccount = (state, { payload }) => ({
  ...state,
  editing: {
    ...Object.keys(payload).reduce(
      (re, k) => {
        set(re, k, payload[k]);
        return re;
      },
      { ...state.editing }
    ),
  },
});

export const addCustomField = (state) => ({
  ...state,
  editing: {
    ...state.editing,
    customFields: [...state.editing.customFields, { key: '', label: '' }],
  },
});
export const removeCustomField = (state, { payload }) => ({
  ...state,
  editing: {
    ...state.editing,
    customFields: state.editing.customFields
      .map((c, i) => (i === payload ? { ...c, deleted: true } : { ...c }))
      .filter((c, i) => c._id || i !== payload),
  },
});

//Groups
export const modifyCustomField = (state, { payload }) => {
  findAndModify(state.editing._custom, payload);
  return {
    ...state,
    editing: {
      ...state.editing,
      ...payload,
    },
  };
};

export const findAndModify = (_custom, payload) => {
  const keys = Object.getOwnPropertyNames(payload);
  const key = keys[0];
  const value = payload[key];
  let banderaExiste = false;
  _custom.forEach((element) => {
    if (element.key == key) {
      element.value = value;
      banderaExiste = true;
    }
  });
  if (!banderaExiste) _custom.push({ key, value });
  return _custom;
};
//Groups

const reducers = {
  [RESET_SUBACCOUNT_FORM]: resetForm,
  [GET_SUBACCOUNT_BY_ID]: {
    [PENDING]: getByIdPending,
    [REJECTED]: getByIdRejected,
    [FULFILLED]: getByIdFulfilled,
  },
  [GET_SUBACCOUNT_FORM_CONFIG]: {
    [PENDING]: getConfigPending,
    [REJECTED]: getConfigRejected,
    [FULFILLED]: getConfigFulfilled,
  },
  [MODIFY_EDITING_SUBACCOUNT]: modifySubaccount,
  [ADD_CUSTOM_FIELD_EDITING_SUBACCOUNT]: addCustomField,
  [MODIFY_CUSTOM_FIELD_EDITING_SUBACCOUNT]: modifyCustomField, //Groups
  [REMOVE_CUSTOM_FIELD_EDITING_SUBACCOUNT]: removeCustomField,
};

export default TypeToReducer(reducers, initialState);



// WEBPACK FOOTER //
// src/modules/secured/modules/subaccounts/reducers/subaccounts_form_reducers.js